import http from '@/communication/AuthConnection'

export default (data) => {
  return http.put(`/v1/user/${data._id}`, data)
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/user/EditUser.js